import React from 'react';
import MetaTags from 'react-meta-tags';  // Added Meta Tag npm Package
import { Container, Row, Col, Card, CardBody, CardTitle, CardText } from "reactstrap";
import { useParams } from 'react-router-dom';

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";

    const ExitInterviewSubmitted = () => {
        return (
            <>
                <div className="page-content">
                    <MetaTags>
                    <title>Submitted | BRIDGE</title>
                    </MetaTags>
                    <Container fluid={true}>
                        <Breadcrumbs title="Human Resource Management" breadcrumbItem="Submitted" />
                        <Row className="d-flex justify-content-center">
                                <Col lg={8} >
                                <Card outline color="success" className="border">
                                    <CardBody>
                                    <CardTitle className="mb-4 text-white">
                                        
                                    </CardTitle>
                                    <CardText>
                                        
                                    </CardText>
                                    <div className="text-center">
                                        <div className="mb-4">
                                        <i className="mdi mdi-check-circle-outline text-success display-4" />
                                        </div>
                                        <div>
                                        <h5>Submitted</h5>
                                        <p className="text-muted">
                                                Exit Interview Submitted
                                        </p>
                                        </div>
                                    </div>
                                    </CardBody>
                                </Card>
                                </Col>
                            </Row>
                        
                           

                    </Container>
                </div>
            </>
        );
    }

export default ExitInterviewSubmitted;